import { useEffect, useState } from "react";
import axiosClient from "../../axios";
import { useUser } from "../../contexts/UserContext";

const LastLearnRoute = () => {
  const [lastRoute, setLastRoute] = useState(null);
  const { user, loading } = useUser();
  const [error, setError] = useState(null);
  const [routeLoading, setRouteLoading] = useState(true);

  useEffect(() => {
    if (!loading && user) {
      setRouteLoading(true);
      axiosClient
        .get("/api/last-learn-route")
        .then((response) => {
          setLastRoute(response.data.route);
          setError(null);
        })
        .catch((err) => {
          setError("Unable to fetch the last visited route.");
          console.error(err);
        })
        .finally(() => {
          setRouteLoading(false);
        });
    }
  }, [loading, user]);

  if (loading || routeLoading) {
    return (
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body text-center py-4">
          <div
            className="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mt-2 mb-0">Loading your progress...</p>
        </div>
      </div>
    );
  }

  if (!user) return null;

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-header bg-white py-3">
        <h5 className="card-title mb-0 d-flex align-items-center">
          <i className="bi bi-compass text-primary me-2"></i>
          Learning Progress
        </h5>
      </div>

      <div className="card-body">
        {/* Welcome message */}
        <div className="d-flex align-items-center mb-3">
          <div
            className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: "40px", height: "40px" }}
          >
            <i className="bi bi-person text-white"></i>
          </div>
          <div>
            <p className="fw-semibold mb-0">Welcome back, {user.name}!</p>
            <small className="text-muted">
              Ready to continue your learning journey?
            </small>
          </div>
        </div>

        {/* Last route content */}
        {lastRoute ? (
          <div className="bg-light rounded p-3">
            <div className="d-flex align-items-center mb-2">
              <i className="bi bi-clock-history text-primary me-2"></i>
              <span className="fw-medium">
                Continue from where you left off
              </span>
            </div>
            <p className="text-muted small mb-2">
              Pick up right where you stopped learning
            </p>
            <a
              href={lastRoute}
              className="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <i className="bi bi-play-circle me-2"></i>
              Continue Learning
            </a>
          </div>
        ) : (
          <div className="text-center py-3">
            <i className="bi bi-journal-plus display-6 text-muted mb-2 d-block"></i>
            <p className="text-muted mb-2">
              No previous learning session found
            </p>
            <p className="text-muted small">
              Start a new learning journey to track your progress
            </p>
          </div>
        )}

        {/* Error message */}
        {error && (
          <div
            className="alert alert-warning mt-3 d-flex align-items-center"
            role="alert"
          >
            <i className="bi bi-exclamation-triangle me-2"></i>
            <div>{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LastLearnRoute;
